<template>
  <ProductSliderContainer
    ref="relatedSimilarProductsNode"
    :products="similarProductsOrdered"
    :loading="similarProductsLoading"
    :title="$t('Similar products')"
    :size="size"
    :product-box-type-tag="EVENT_SOURCE.PDP_SIMILAR_PRODUCTS"
    :has-arrows="hasArrows"
    @product-clicked="(product) => parentClicked(product)"
  />
</template>

<script lang="ts">

import { useIntersectionObserver } from '@vueuse/core';

import { EVENT_SOURCE } from '~~/constants/googleTagManager';
import { PRODUCT_CARD_SIZE } from '~~/constants/productCardSize';
import type { ProductCardSize } from '~~/constants/productCardSize';
import type { ProductVariant } from '~~/types/commercetools';
import { orderProductsByOnSale } from '~~/helpers/product/orderProductsByOnSale';

export default defineComponent({
  name: 'SimilarProducts',

  props: {
    similarProducts: {
      type: Array as PropType<ProductVariant[]>,
      required: true,
    },
    sourceSku: {
      type: String,
      required: true,
    },
    similarProductsLoading: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String as PropType<ProductCardSize>,
      default: PRODUCT_CARD_SIZE.MEDIUM,
      validator: (value: ProductCardSize) => {

        return Object.values(PRODUCT_CARD_SIZE).includes(value);
      
      },
    },
    hasArrows: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {

    const relatedSimilarProductsNode = ref<HTMLElement | null>(null);

    const {
      onIntersectSimilarProductsOnce,
      onClickParentProduct,
    } = useProductRecommendationEvents({
      suggestedSimilarProducts: props.similarProducts,
      sourceProductSku: props.sourceSku,
    });

    useIntersectionObserver(relatedSimilarProductsNode, onIntersectSimilarProductsOnce);

    const parentClicked = (parentSku: string) => {

      onClickParentProduct(parentSku);
    
    };

    const similarProductsOrdered = computed(() => {

      return orderProductsByOnSale(props.similarProducts);
    
    });

    return {
      parentClicked,
      relatedSimilarProductsNode,
      EVENT_SOURCE,
      similarProductsOrdered,
    };
  
  },
});

</script>
